/*
 * This file is part of glowingblue/datavis.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../common';
import DataVis from '../common/models/DataVis';
import DataVisPage from './components/DataVisPage';
import { extend } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';
import LinkButton from 'flarum/common/components/LinkButton';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';

app.initializers.add(slug, () => {
	app.store.models.glowingblue_datavis = DataVis;

	User.prototype.canViewDataVis = Model.attribute('canViewDataVis');

	app.routes.analytics = {
		path: '/analytics',
		component: DataVisPage,
	};

	extend(SessionDropdown.prototype, 'items', (items) => {
		if (app.session?.user?.canViewDataVis() && m.route.get()) {
			items.add(
				'analytics',
				<LinkButton
					href={app.route('analytics')}
					icon='fas fa-chart-pie'
					active={m.route.get().indexOf('/analytics') === 0}>
					Analytics
				</LinkButton>,
				10,
			);
		}
	});
});
